import { render } from "./TV.vue?vue&type=template&id=afed280c&scoped=true"
import script from "./TV.vue?vue&type=script&lang=js"
export * from "./TV.vue?vue&type=script&lang=js"

import "./TV.vue?vue&type=style&index=0&id=afed280c&scoped=true&lang=css"

import exportComponent from "E:\\coding\\pharaoh_frog_barber\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afed280c"]])

export default __exports__